import React, { useState } from 'react';
import Main from 'components/Main/Main';
import { Button, Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import Avancar from 'shared/icons/Avancar';
import Voltar from 'shared/icons/Voltar';
import Grid from 'components/commom/Grid';
import UploadCnab400 from './UploadCnab400/UploadCnab400';
import { getClienteAtual, SkeletonLoader } from '../../shared';
import useDataGridColumns from './DataGrid/DataGridColumns';
import useAtualizacaoTitulo from './Hooks/useAtualizacaoTitulo';

import './styles.scss';
import AtualizacaoTituloFiltros from './Filtro/AtualizacaoTituloFiltros';

const AtualizacaoTitulo = props => {
  const clienteAtual = getClienteAtual();
  const [collapseMenuRight, setCollapseMenuRight] = useState(window.innerWidth <= 600);

  const {
    files,
    isUploading,
    deleteFile,
    retryUpload,
    filesAcceptedHandler,
    processarArquivos,
    viewMode,
    gridData,
    isLoading,
    verRegistros,
    voltarArquivos,
    baixarArquivoImportadoS3,
    filtrosAplicados,
    aplicarFiltros,
    limparFiltros,
    downloadingUuid,
    downloadingRef
  } = useAtualizacaoTitulo({
    clienteAtual: clienteAtual
  });

  const cols = useDataGridColumns({
    verRegistros,
    baixarArquivoImportadoS3,
    downloadingRef
  });

  const handleApplyFilters = async values => {
    await aplicarFiltros(values);
  };

  const handleClearFilters = async () => {
    await limparFiltros();
  };

  return (
    <Main className={`at-page ${collapseMenuRight ? 'at-collapsed' : ''}`} {...props}>
      <Card className="at-card">
        <CardBody className="at-card__body">
          <div className="at-layout">
            <div
              className={`at-layout__content ${
                !collapseMenuRight ? 'at-layout__content--with-filter' : ''
              }`}
            >
              <div className="at-content">
                <CardHeader className="d-flex align-items-center at-content__header">
                  <CardTitle className="mb-0">
                    {viewMode === 'ARQUIVOS'
                      ? 'Lista de arquivos importados/importar'
                      : 'Lista de títulos processados'}
                  </CardTitle>

                  {collapseMenuRight && (
                    <button
                      type="button"
                      onClick={() => setCollapseMenuRight(false)}
                      title="Filtros"
                      className="at-btn-filtros btn-primary"
                    >
                      <i className="fa fa-angle-left" />
                      <span>Filtros</span>
                    </button>
                  )}
                </CardHeader>

                <div className="at-content__body">
                  {viewMode === 'ARQUIVOS' && (
                    <>
                      <UploadCnab400
                        files={files}
                        isUploading={isUploading}
                        deleteFile={deleteFile}
                        retryUpload={retryUpload}
                        filesAcceptedHandler={filesAcceptedHandler}
                      />

                      {files.length > 0 && (
                        <Button
                          className="at-btn-avancar"
                          size="lg"
                          color="primary"
                          type="button"
                          disabled={files.length === 0 || isUploading}
                          onClick={processarArquivos}
                        >
                          {isUploading ? 'Processando...' : 'Processar'}
                          <i className="svg-icon at-btn-avancar__icon">
                            <Avancar />
                          </i>
                        </Button>
                      )}
                    </>
                  )}

                  {isLoading ? (
                    <SkeletonLoader
                      isPending={isLoading}
                      width="98%"
                      height="40px"
                      count={8}
                      widthRandomness={0}
                    />
                  ) : (
                    <Grid
                      keyField="uuid"
                      data={gridData}
                      classes="table-layout-auto"
                      configuracaoColunas={
                        viewMode === 'ARQUIVOS' ? cols.colunasArquivos : cols.colunasRegistros
                      }
                      classeIdentificadora={
                        viewMode === 'ARQUIVOS' ? 'listagem-at-arquivos' : 'listagem-at-registros'
                      }
                      extraRenderKey={downloadingUuid}
                    />
                  )}

                  {viewMode === 'REGISTROS' && (
                    <div style={{ marginTop: 12, display: 'flex' }}>
                      <Button color="primary" type="button" onClick={voltarArquivos}>
                        <i className="svg-icon at-btn-voltar__icon">
                          <Voltar />
                        </i>
                        Voltar
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <AtualizacaoTituloFiltros
              collapsed={collapseMenuRight}
              clienteAtual={clienteAtual}
              filtrosAplicados={filtrosAplicados}
              onClose={() => setCollapseMenuRight(true)}
              onApply={handleApplyFilters}
              onClear={handleClearFilters}
            />
          </div>
        </CardBody>
      </Card>
    </Main>
  );
};

export default AtualizacaoTitulo;
